export default "__VITE_ASSET__DOk8$G3N__"